var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aw-about-us aw-news-index"},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-sub-top"},[_c('div',{staticClass:"title container-center"},[_vm._v("企业新闻")])])
}]

export { render, staticRenderFns }